import { FaSpinner } from 'react-icons/fa';

const Spinner = (props) => (
	<div className='spinner-wrapper'>
		<FaSpinner icon='spinner' className='spinner' size={props.size || 25} color={props.color || '#42405F'} />
	</div>
);

export default Spinner;
